<div class="modal">
  <div class="modal-overlay" (click)="close($event)"></div>

  <div class="modal-dialog" role="document">
    <div class="modal-content">

      <div class="modal-header">
        <span class="modal-title">{{modalTitle}}</span>
        <span class="me-auto"></span>
        <i class="btn btn-danger bi bi-x-lg" (click)="close($event)"></i>
      </div>

      <div class="modal-body">
        <div class="text-center m-3" [innerHtml]="modalText"></div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-success" data-bs-dismiss="modal" i18n="@@DialogConfirmYesButton"
          (click)="yes($event)">Yes</button>
        <button type="button" class="btn btn-warning" data-bs-dismiss="modal" i18n="@@DialogConfirmNoButton"
          (click)="no($event)">No</button>
      </div>

    </div>
  </div>

</div>
